import { Amenity } from "@/types/amenity";
import { Typography } from "../ui/typography";
import { AmenityIcon } from "./AmenityIcon";

export const AmenityItem: React.FC<{ amenity: Amenity }> = ({ amenity }) => (
  <div className="flex items-center gap-3">
    <AmenityIcon slug={amenity.slug} title={amenity.title} />
    <Typography variant="bodySMedium" className="text-[13px] md:text-sm">
      {amenity.title}
    </Typography>
  </div>
);
